import { imageDeliveryUrl } from "src/../src-dynamic/destination.config";

export function getImageDeliveryUrl() {
  return imageDeliveryUrl || "public-assets.spotliodata.com";
}